import api from '../api-methods'

const proxyIo = process.env.VUE_APP_ENV === 'local' ? '/proxy_io' : process.env.VUE_APP_IO

const io = {
  reportedData: payload => {
    return api.post(proxyIo + `/v2/reported_data/${payload.data_type}`, payload)
  },
  reportedSemData: payload => {
    return api.post(proxyIo + '/v1/sem_upload_data', payload)
  }
}

export default io